import { Session } from "@models/ISchema";
import { EditedSession } from "../context/formData.reducer";

const sessionHasIntervals = (session: Session | EditedSession): boolean => {
  const hasAssignment = Object.prototype.hasOwnProperty.call(session, "assignment");
  const intervals = (session as Session)?.assignment?.intervals;
  const hasIntervals = intervals == null || intervals.length > 0;
  return hasAssignment && hasIntervals;
};

/**
 * Return a copy of the given `Sessions | EditedSessions` ordered by the ids of
 * it's assigned weeks.
 *
 * @param sessions (Session | EditedSession)[]
 * @return (Session | EditedSession)[]
 */
const orderSessionsByWeeks = (sessions: (Session | EditedSession)[]): (Session | EditedSession)[] =>
  [...sessions].sort((s1, s2) => {
    const s1HasIntervals = sessionHasIntervals(s1);
    const s2HasIntervals = sessionHasIntervals(s2);

    if (!s1HasIntervals && !s2HasIntervals) return 0;
    else if (!s1HasIntervals) return -1;
    else if (!s2HasIntervals) return 1;

    const fstWeekId = (s1 as Session)?.assignment?.intervals?.[0]?.id ?? "-";
    const scdWeekId = (s2 as Session)?.assignment?.intervals?.[0]?.id ?? "-";

    return fstWeekId < scdWeekId ? -1 : fstWeekId === scdWeekId ? 0 : 1;
  });

export default orderSessionsByWeeks;
